// El ícono de un servicio: el PNG de services.icon; si falta el archivo, o
// el servicio no tiene ícono, default.png. Lo usan la home y /services.
// Va aparte de utils/servicios.js porque usa require (webpack) y aquel se
// prueba con node tal cual.
export const iconoDeServicio = (icon) => {
  if (icon) {
    try { return require(`../assets/images/icons/${icon}`); } catch { /* cae al default */ }
  }
  return require('../assets/images/icons/default.png');
};

// El mismo ícono con el contorno exterior en dorado, para las tarjetas azules de
// "Los más pedidos". Los archivos de icons/destacados/ NO se editan a mano: los
// genera ~/fixo-scripts/generar_iconos_destacados.js desde los originales, y
// pruebas/prueba_iconos_destacados.js falla si quedaron desactualizados.
export const iconoDestacado = (icon) => {
  if (icon) {
    try { return require(`../assets/images/icons/destacados/${icon}`); } catch { /* cae al default */ }
  }
  return require('../assets/images/icons/destacados/default.png');
};
